<template>
    <v-autocomplete
      :items="schema.items"
      :label="schema.label"
      :prepend-icon="schema.icon"
      item-text="label"
      item-value="value"
      :name="name"
      :type="schema.type "
      :rules="selectRules"
      :solo="schema.solo"
      @input="handleInput"
      return-object
      :required="!schema.optional"
      :error-messages="errorMessages"
      />
</template>

<script>
export default {
  name: 'singleSelect',
  props: {
    /** Validation Errors */
    errorMessages: { type: String },
    /** Field Name */
    name: { type: String, required: true },
    /** Field Schema */
    schema: { type: Object, default: () => ({}) },
    /** Disabled state */
    disabled: { type: Boolean, default: false }
  },
  data () {
    return {
      selectRules: [v => !!v || 'Debe seleccionar un campo']
    }
  },
  /** Validation Rules */
  /* validationRules () {
    const rules = []
    // Required validation
    if (!this.schema.optional) {
      rules.push((v) => v || 'Campo requerido.')
    }
    return rules
  } */
  methods: {
    /** Input event handler */
    handleInput (...args) {
      this.$emit('input', ...args)
    }
  }
}
</script>
